import React from 'react';
import { motion } from 'framer-motion';
export function DirectorsSection() {
  return <section id="equipo" className="py-24 bg-kiron-black relative" data-id="element-45">
      <div className="max-w-7xl mx-auto px-6" data-id="element-46">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mb-16 text-center" data-id="element-47">
          <h2 className="text-4xl md:text-5xl font-oswald font-bold text-white mb-4" data-id="element-48">
            Nuestra <span className="text-kiron-teal" data-id="element-49">Dirección</span>
          </h2>
          <div className="w-20 h-1 bg-kiron-teal mx-auto" data-id="element-50"></div>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-12" data-id="element-51">
          {/* Matias Saggese */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="group relative overflow-hidden bg-kiron-darker" data-id="element-52">
            <div className="aspect-[3/4] w-full overflow-hidden" data-id="element-53">
              <img src="https://cdn.magicpatterns.com/uploads/jj4iGnpTW9NWZK4uTh2kSi/SaveClip.App_537040841_17855327496508306_8108097126173545127_n.jpg" alt="Prof. Matias Saggese" className="w-full h-full object-cover object-top grayscale group-hover:grayscale-0 transition-all duration-500 scale-105 group-hover:scale-100" data-id="element-54" />
            </div>
            <div className="absolute bottom-0 left-0 w-full p-6 bg-gradient-to-t from-kiron-black via-kiron-black/80 to-transparent pt-20" data-id="element-55">
              <div className="border-l-4 border-kiron-teal pl-4" data-id="element-56">
                <h3 className="text-3xl font-oswald font-bold text-white uppercase tracking-wide mb-1" data-id="element-57">
                  Matias Saggese
                </h3>
                <p className="text-kiron-teal font-medium uppercase tracking-wider text-sm" data-id="element-58">
                  Lic. en Alto Rendimiento
                </p>
              </div>
            </div>
          </motion.div>

          {/* Mariela Jorge */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="group relative overflow-hidden bg-kiron-darker" data-id="element-59">
            <div className="aspect-[3/4] w-full overflow-hidden" data-id="element-60">
              <img src="https://cdn.magicpatterns.com/uploads/oKwMmoJzde8KKLDjDrtsy6/SaveClip.App_536375075_17855327835508306_7054355897468831113_n.jpg" alt="Lic. Mariela Jorge" className="w-full h-full object-cover object-top grayscale group-hover:grayscale-0 transition-all duration-500 scale-105 group-hover:scale-100" data-id="element-61" />
            </div>
            <div className="absolute bottom-0 left-0 w-full p-6 bg-gradient-to-t from-kiron-black via-kiron-black/80 to-transparent pt-20" data-id="element-62">
              <div className="border-l-4 border-kiron-teal pl-4" data-id="element-63">
                <h3 className="text-3xl font-oswald font-bold text-white uppercase tracking-wide mb-1" data-id="element-64">
                  Mariela Jorge
                </h3>
                <div className="flex flex-col space-y-1" data-id="element-65">
                  <p className="text-kiron-teal font-medium uppercase tracking-wider text-sm" data-id="element-66">
                    Lic. en Kinesiología y Fisiatría
                  </p>
                  <p className="text-gray-300 text-xs uppercase tracking-wider" data-id="element-67">
                    Osteópata • Esp. Kinesiología Deportiva
                  </p>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}